import axios from 'axios';
import {serverUrl} from "../../../config";

export default class AdvetsService{
  static getAdverts(data){
    const url = `${serverUrl}api/broker/home/adverts`;
    return axios.post(url, data);
  }
}
